import type ReadOnlyRecipientViewState from 'owa-recipient-types/lib/types/ReadOnlyRecipientViewState';
import type RecipientWellWithFindControlViewState from 'owa-recipient-types/lib/types/RecipientWellWithFindControlViewState';
import type EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import convertRecipientsToViewState from 'owa-recipient-create-viewstate/lib/util/convertRecipientsToViewState';

export default function mergeReadWriteRecipientWellIntoReadOnly(
    readWriteRecipientWell: RecipientWellWithFindControlViewState,
    readOnlyRecipientArray: ReadOnlyRecipientViewState[]
) {
    if (readWriteRecipientWell?.recipients) {
        const wrappers: EmailAddressWrapper[] = readWriteRecipientWell.recipients.map(
            recip => recip.persona.EmailAddress
        );
        const converted: ReadOnlyRecipientViewState[] = convertRecipientsToViewState(wrappers);
        if (converted !== undefined) {
            readOnlyRecipientArray.push(...converted);
        }
    }
}
